import {push} from "connected-react-router";
import { PHOTO_ROUTE} from "../components/Root/routes";

const showPhoto= () => async (dispatch) =>
{
    dispatch(push(PHOTO_ROUTE));
};
export default showPhoto;